<template>
    <div class="sah-modal__wrapper" v-show="modalIsShown">
        <div class="sah-modal">
            <div class="sah-modal__name">
                {{ $tc("app.name") }}
            </div>
            <div class="sah-modal__content" v-html="modalMessage"></div>
            <div class="sah-modal__controls">
                <sah-button v-if="isConfirm" class="app__button_alt" @click.prevent.native="reply(false)">
                    {{ $tc("words.cancel") }}
                </sah-button>
                <sah-button v-if="isConfirm" @click.prevent.native="reply(true)">
                    {{ $tc("words.confirm") }}
                </sah-button>
                <sah-button v-if="isAlert" @click.prevent.native="$modal.hide()">
                    {{ $tc("words.ok") }}
                </sah-button>
                <sah-button v-if="isError" @click.prevent.native="acknowledgeError()">
                    {{ $tc("words.ok") }}
                </sah-button>
            </div>
        </div>
    </div>
</template>

<script>
import {store, SahButton} from "atom";
import {MODAL_TYPE_ALERT, MODAL_TYPE_CONFIRM, MODAL_TYPE_ERROR} from "../constants";
const {createNamespacedHelpers} = store;
const {mapActions, mapState} = createNamespacedHelpers("arcman");

/**
 *
 * @vue-prop {Object} warehouse - warehouse
 */
export default {
    name: "sah-modal",
    components: {
        SahButton,
    },
    computed: {
        ...mapState(["modalIsShown", "modalMessage", "modalType"]),
        isAlert() {
            return this.modalType === MODAL_TYPE_ALERT;
        },
        isConfirm() {
            return this.modalType === MODAL_TYPE_CONFIRM;
        },
        isError() {
            return this.modalType === MODAL_TYPE_ERROR;
        },
    },
    methods: {
        ...mapActions({resetError: "RESET_ERROR"}),
        reply(confirm) {
            this.$modal.events.$emit("modal-confirm", confirm);
        },
        acknowledgeError() {
            this.resetError();
            this.$modal.hide();
        },
    },
};
</script>

<style scoped lang="scss">
.sah-modal__wrapper::v-deep {
    @apply fixed top-0 left-0 z-10 h-screen w-screen flex flex-row items-center justify-center;
    background-color: $background-wrapper-edit-color;

    .sah-modal {
        @apply w-4/5 flex flex-col rounded max-h-screen overflow-y-auto;
        background-color: $background-application-color;
        @screen md {
            @apply w-3/5;
        }
        @screen xl {
            @apply w-2/5;
        }
        font-size: $font-small;
    }

    .sah-modal__name {
        @apply font-bold py-3 px-5;
        background-color: $background-card-header-color;
        color: $text-card-header-color;
    }

    .sah-modal__content {
        @apply bg-white py-3 px-5 overflow-y-auto;
    }

    .sah-modal__controls {
        @apply flex justify-end py-3 px-5 mt-4;
        background-color: $background-card-footer-color;
    }
}
</style>
